/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import PoliciesAndProcedures from "./policies-and-procedures";

export default PoliciesAndProcedures;
